import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/jquery.fittext.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$(document).ready(function(){
  $('.ny-banner h1').textillate();
  if($('.ny-banner h2').html() != ''){
    setTimeout(function(){
      $('.ny-banner h2').textillate();
    },800)
  }

  var swiper1 = new Swiper(".host-swiper .mySwiper", {
    speed: 600,
    loop: true,
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      waitForTransition: true,
    },
    pagination: {// 分页
      el: ".host-swiper .swiper-pagination",
      clickable: true,
    },
  })
})